import type { JSX } from 'react'

export const BundleCover2 = (): JSX.Element => (
  <svg
    width='100%'
    height='100%'
    viewBox='0 0 1920 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <g clipPath='url(#clip0_628_270)'>
      <rect width='1920' height='1080' fill='#161616' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M621.027 0C574.134 76.7012 527.815 159.506 486.059 245.041C384.785 452.492 303.463 689.65 319.05 898.119C250.868 953.311 181.195 1013.87 110.724 1080H350.516C354.159 1076.89 357.798 1073.8 361.433 1070.72C362.973 1073.86 364.557 1076.95 366.185 1080H937.777C1019.21 1025.77 1098.08 960.51 1165.82 895.684C1251.01 814.172 1324 728.182 1362.23 660.221C1382.68 623.859 1401.32 570.877 1377.33 518.67C1352.4 464.436 1298.51 446.797 1259.29 441.83C1180.1 431.799 1067.33 458.957 941.633 511.027C810.688 565.273 652.933 651.984 480.98 774.783C495.83 634.557 552.104 474.471 629.841 315.232C684.897 202.455 748.602 94.3223 810.361 0H621.027ZM521.969 1026.26C511.603 1014.41 500.583 995.469 491.975 965.611C687.338 816.23 864.336 716.234 1002.87 658.848C1098.75 619.125 1168.95 602.877 1211.63 600.145C1181.01 647.482 1125.96 712.381 1055.21 780.082C975.743 856.119 881.792 930.602 791.149 982.891C696.959 1037.23 620.861 1059.11 571.706 1052.18C550.459 1049.19 534.851 1040.99 521.969 1026.26Z'
        fill='url(#paint0_linear_628_270)'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 889.496C434.983 637.5 1117.33 256.986 1656.47 -0.5H1920V53.6523C1339.11 313.477 479.18 794.84 0 1074.58V889.496Z'
        fill='url(#paint1_linear_628_270)'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_628_270'
        x1='749.672'
        y1='0'
        x2='749.672'
        y2='1080'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#1E0A36' />
        <stop offset='1' stopColor='#380B1F' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_628_270'
        x1='960'
        y1='-0.5'
        x2='960'
        y2='1074.58'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#2B0D4F' />
        <stop offset='1' stopColor='#4B0D29' />
      </linearGradient>
      <clipPath id='clip0_628_270'>
        <rect width='1920' height='1080' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
